module.exports = __webpack_public_path__ + "img/h2.5c395280.png";